module.exports = __webpack_public_path__ + "img/not-found.e531f59d.svg";